/* eslint-disable */
import tinymce from 'tinymce/tinymce'
import 'tinymce/themes/silver'
import 'tinymce/icons/default'
import 'tinymce/skins/ui/oxide/skin.css'

// Import all plugins used in the project
import 'tinymce/plugins/preview'
import 'tinymce/plugins/searchreplace'
import 'tinymce/plugins/autolink'
import 'tinymce/plugins/fullscreen'
import 'tinymce/plugins/image'
import 'tinymce/plugins/link'
import 'tinymce/plugins/media'
import 'tinymce/plugins/code'
import 'tinymce/plugins/codesample'
import 'tinymce/plugins/charmap'
import 'tinymce/plugins/pagebreak'
import 'tinymce/plugins/nonbreaking'
import 'tinymce/plugins/anchor'
import 'tinymce/plugins/advlist'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/help'
import 'tinymce/plugins/emoticons'
import 'tinymce/plugins/emoticons/js/emojis'
import 'tinymce/plugins/autosave'
import 'tinymce/plugins/quickbars'
import 'tinymce/plugins/wordcount'
import 'tinymce/plugins/autoresize'
import 'tinymce/plugins/table'
import 'tinymce/plugins/imagetools'
import 'tinymce/plugins/paste'

// Language
tinymce.addI18n('zh_CN', {
  Redo: '恢复',
  Undo: '撤销',
  Cut: '剪切',
  Copy: '复制',
  Paste: '粘贴',
  'Select all': '全选',
  'New document': '新建文档',
  Ok: '确定',
  Cancel: '取消',
  'Visual aids': '网格线',
  Bold: '粗体',
  Italic: '斜体',
  Underline: '下划线',
  Strikethrough: '删除线',
  Superscript: '上标',
  Subscript: '下标',
  'Clear formatting': '清除格式',
  'Align left': '左对齐',
  'Align center': '居中',
  'Align right': '右对齐',
  Justify: '两端对齐',
  'Bullet list': '符号列表',
  'Numbered list': '数字列表',
  'Decrease indent': '减少缩进',
  'Increase indent': '增加缩进',
  Close: '关闭',
  Formats: '格式',
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X\/C\/V keyboard shortcuts instead.": '当前浏览器不支持访问剪贴板，请使用快捷键Ctrl+X/C/V复制粘贴',
  Headers: '标题',
  'Header 1': '标题1',
  'Header 2': '标题2',
  'Header 3': '标题3',
  'Header 4': '标题4',
  'Header 5': '标题5',
  'Header 6': '标题6',
  Headings: '标题',
  'Heading 1': '标题1',
  'Heading 2': '标题2',
  'Heading 3': '标题3',
  'Heading 4': '标题4',
  'Heading 5': '标题5',
  'Heading 6': '标题6',
  Preformatted: '预格式化',
  Div: 'Div区块',
  Pre: '预格式文本',
  Code: '代码',
  Paragraph: '段落',
  Blockquote: '引用',
  Inline: '文本',
  Blocks: '区块',
  'Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.': '当前为纯文本粘贴模式，再次点击可以回到普通粘贴模式。',
  Fonts: '字体',
  'Font Sizes': '字号',
  Class: 'Class',
  'Browse for an image': '浏览图像',
  OR: '或',
  'Drop an image here': '拖放一张图片文件至此',
  Upload: '上传',
  Block: '块',
  Align: '对齐',
  Default: '默认',
  Circle: '空心圆',
  Disc: '实心圆',
  Square: '方块',
  'Lower Alpha': '小写英文字母',
  'Lower Greek': '小写希腊字母',
  'Lower Roman': '小写罗马字母',
  'Upper Alpha': '大写英文字母',
  'Upper Roman': '大写罗马字母',
  'Anchor...': '锚点...',
  Name: '名称',
  Id: 'id',
  'Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.': 'id应该以字母开头，后跟字母、数字、横线、点、冒号或下划线。',
  'You have unsaved changes are you sure you want to navigate away?': '你对文档的修改尚未保存，确定离开吗？',
  'Restore last draft': '恢复上次的草稿',
  'Special characters...': '特殊字符...',
  'Source code': 'HTML源码',
  'Insert\/Edit code sample': '插入/编辑代码示例',
  Language: '语言',
  'Code sample...': '代码示例...',
  'Color Picker': '选取颜色',
  R: 'R',
  G: 'G',
  B: 'B',
  'Left to right': '从左到右',
  'Right to left': '从右到左',
  'Emoticons...': '表情符号...',
  'Metadata and Document Properties': '元数据和文档属性',
  Title: '标题',
  Keywords: '关键词',
  Description: '描述',
  Robots: '机器人',
  Author: '作者',
  Encoding: '编码',
  Fullscreen: '全屏',
  Action: '操作',
  Shortcut: '快捷键',
  Help: '帮助',
  Address: '地址',
  'Focus to menubar': '聚焦到菜单栏',
  'Focus to toolbar': '聚焦到工具栏',
  'Focus to element path': '聚焦到元素路径',
  'Focus to contextual toolbar': '聚焦到上下文工具栏',
  'Insert link (if link plugin activated)': '插入链接 (如果链接插件已激活)',
  'Save (if save plugin activated)': '保存(如果保存插件已激活)',
  'Find (if searchreplace plugin activated)': '查找(如果查找替换插件已激活)',
  'Plugins installed ({0}):': '已安装插件 ({0}):',
  'Premium plugins:': '高级插件:',
  'Learn more...': '了解更多...',
  'You are using {0}': '你正在使用 {0}',
  Plugins: '插件',
  'Handy Shortcuts': '快捷键',
  'Horizontal line': '水平分割线',
  'Insert\/edit image': '插入/编辑图片',
  'Alternative description': '替代描述',
  Accessibility: '辅助功能',
  'Image is decorative': '图片是装饰性的',
  Source: '地址',
  Dimensions: '大小',
  'Constrain proportions': '保持纵横比',
  General: '常规',
  Advanced: '高级',
  Style: '样式',
  'Vertical space': '垂直边距',
  'Horizontal space': '水平边距',
  Border: '边框',
  'Insert image': '插入图片',
  'Image...': '图片...',
  'Image list': '图片列表',
  'Rotate counterclockwise': '逆时针旋转',
  'Rotate clockwise': '顺时针旋转',
  'Flip vertically': '垂直翻转',
  'Flip horizontally': '水平翻转',
  'Edit image': '编辑图片',
  'Image options': '图片选项',
  'Zoom in': '放大',
  'Zoom out': '缩小',
  Crop: '裁剪',
  Resize: '调整大小',
  Orientation: '方向',
  Brightness: '亮度',
  Sharpen: '锐化',
  Contrast: '对比度',
  'Color levels': '颜色层次',
  Gamma: '伽马值',
  Invert: '反转',
  Apply: '应用',
  Back: '后退',
  'Insert date\/time': '插入日期/时间',
  'Date\/time': '日期/时间',
  'Insert\/edit link': '插入/编辑链接',
  'Text to display': '显示文字',
  Url: '地址',
  'Open link in...': '链接打开位置...',
  'Current window': '当前窗口',
  None: '无',
  'New window': '新窗口',
  'Open link': '打开链接',
  'Remove link': '删除链接',
  Anchors: '锚点',
  'Link...': '链接...',
  'Paste or type a link': '粘贴或输入链接',
  'The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?': '你所输入的URL似乎是一个邮箱地址，需要加上mailto:前缀吗？',
  'The URL you entered seems to be an external link. Do you want to add the required http:\/\/ prefix?': '你所输入的URL似乎是一个外部链接，需要加上http://前缀吗？',
  'The URL you entered seems to be an external link. Do you want to add the required https:\/\/ prefix?': '你所输入的URL似乎是一个外部链接，需要加上https://前缀吗？',
  'Link list': '链接列表',
  'Insert video': '插入视频',
  'Insert\/edit video': '插入/编辑视频',
  'Insert\/edit media': '插入/编辑媒体',
  'Alternative source': '替代地址',
  'Alternative source URL': '替代地址URL',
  'Media poster (Image URL)': '封面(图片地址)',
  'Paste your embed code below:': '将内嵌代码粘贴在下面:',
  Embed: '内嵌',
  'Media...': '媒体...',
  'Nonbreaking space': '不间断空格',
  'Page break': '分页符',
  'Paste as text': '粘贴为文本',
  Preview: '预览',
  'Print...': '打印...',
  Save: '保存',
  Find: '查找',
  'Replace with': '替换为',
  Replace: '替换',
  'Replace all': '全部替换',
  Previous: '上一个',
  Next: '下一个',
  'Find and replace...': '查找并替换...',
  'Could not find the specified string.': '未找到搜索内容。',
  'Match case': '区分大小写',
  'Find whole words only': '全字匹配',
  'Find in selection': '在选区中查找',
  Spellcheck: '拼写检查',
  'Spellcheck Language': '拼写检查语言',
  'No misspellings found.': '没有发现拼写错误。',
  Ignore: '忽略',
  'Ignore all': '全部忽略',
  Finish: '完成',
  'Add to Dictionary': '添加到字典',
  'Insert table': '插入表格',
  'Table properties': '表格属性',
  'Delete table': '删除表格',
  Cell: '单元格',
  Row: '行',
  Column: '列',
  'Cell properties': '单元格属性',
  'Merge cells': '合并单元格',
  'Split cell': '拆分单元格',
  'Insert row before': '在上方插入行',
  'Insert row after': '在下方插入行',
  'Delete row': '删除行',
  'Row properties': '行属性',
  'Cut row': '剪切行',
  'Copy row': '复制行',
  'Paste row before': '粘贴到上方',
  'Paste row after': '粘贴到下方',
  'Insert column before': '在左侧插入列',
  'Insert column after': '在右侧插入列',
  'Delete column': '删除列',
  Cols: '列',
  Rows: '行',
  Width: '宽',
  Height: '高',
  'Cell spacing': '单元格间距',
  'Cell padding': '单元格边距',
  'Show caption': '显示标题',
  Left: '左对齐',
  Center: '居中',
  Right: '右对齐',
  'Cell type': '单元格类型',
  Scope: '范围',
  Alignment: '对齐方式',
  'H Align': '水平对齐',
  'V Align': '垂直对齐',
  Top: '顶部对齐',
  Middle: '垂直居中',
  Bottom: '底部对齐',
  'Header cell': '表头单元格',
  'Row group': '行组',
  'Column group': '列组',
  'Row type': '行类型',
  Header: '表头',
  Body: '表体',
  Footer: '表尾',
  'Border color': '边框颜色',
  'Insert template...': '插入模板...',
  Templates: '模板',
  Template: '模板',
  'Text color': '文字颜色',
  'Background color': '背景色',
  'Custom...': '自定义...',
  'Custom color': '自定义颜色',
  'No color': '无',
  'Remove color': '移除颜色',
  'Show blocks': '显示区块',
  'Show invisible characters': '显示不可见字符',
  'Word count': '字数统计',
  Count: '计数',
  Document: '文档',
  Selection: '选择',
  Words: '字',
  'Words: {0}': '字数：{0}',
  '{0} words': '{0} 字',
  File: '文件',
  Edit: '编辑',
  Insert: '插入',
  View: '视图',
  Format: '格式',
  Table: '表格',
  Tools: '工具',
  'Powered by {0}': 'Powered by {0}',
  'Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help': '在编辑区按ALT-F9打开菜单，按ALT-F10打开工具栏，按ALT-0查看帮助',
  'Image title': '图片标题',
  'Border width': '边框宽度',
  'Border style': '边框样式',
  Error: '错误',
  Warn: '警告',
  Valid: '有效',
  'To open the popup, press Shift+Enter': '按Shift+Enter打开对话框',
  'Rich Text Area. Press ALT-0 for help.': '编辑区。按Alt+0查看帮助。',
  'System Font': '系统字体',
  'Failed to upload image: {0}': '图片上传失败: {0}',
  'Failed to load plugin: {0} from url {1}': '插件加载失败: {0} 来自链接 {1}',
  'Failed to load plugin url: {0}': '插件加载失败: {0}',
  'Failed to initialize plugin: {0}': '插件初始化失败: {0}',
  example: '示例',
  Search: '搜索',
  All: '全部',
  Currency: '货币',
  Text: '文本',
  Quotations: '引用',
  Mathematical: '数学',
  'Extended Latin': '拉丁语扩充',
  Symbols: '符号',
  Arrows: '箭头',
  'User Defined': '用户定义',
  'dollar sign': '美元符号',
  'currency sign': '货币符号',
  'euro-currency sign': '欧元符号',
  'colon sign': '科朗符号',
  'cruzeiro sign': '克鲁赛罗符号',
  'french franc sign': '法郎符号',
  'lira sign': '里拉符号',
  'mill sign': '密尔符号',
  'naira sign': '奈拉符号',
  'peseta sign': '比塞塔符号',
  'rupee sign': '卢比符号',
  'won sign': '韩元符号',
  'new sheqel sign': '新谢克尔符号',
  'dong sign': '越南盾符号',
  'kip sign': '基普符号',
  'tugrik sign': '图格里克符号',
  'drachma sign': '德拉克马符号',
  'german penny symbol': '德国便士符号',
  'peso sign': '比索符号',
  'guarani sign': '瓜拉尼符号',
  'austral sign': '奥斯特拉尔符号',
  'hryvnia sign': '格里夫尼亚符号',
  'cedi sign': '塞地符号',
  'livre tournois sign': '里弗尔符号',
  'spesmilo sign': '斯佩斯米洛符号',
  'tenge sign': '坚戈符号',
  'indian rupee sign': '印度卢比符号',
  'turkish lira sign': '土耳其里拉符号',
  'nordic mark sign': '北欧马克符号',
  'manat sign': '马纳特符号',
  'ruble sign': '卢布符号',
  'yen character': '日元符号',
  'yuan character': '人民币符号',
  'yuan/yen character': '元/円符号',
  'won character': '韩元符号',
  'latin capital letter a with macron': 'Macron A',
  'latin capital letter a with breve': 'Breve A',
  'latin capital letter a with ogonek': 'Ogonek A',
  'latin capital letter c with acute': 'Acute C',
  'latin capital letter c with circumflex': 'Circumflex C',
  'latin capital letter c with dot above': 'Dot above C',
  'latin capital letter c with caron': 'Caron C',
  'latin capital letter d with caron': 'Caron D',
  'latin capital letter d with stroke': 'Stroke D',
  'latin capital letter e with macron': 'Macron E',
  'latin capital letter e with breve': 'Breve E',
  'latin capital letter e with dot above': 'Dot above E',
  'latin capital letter e with ogonek': 'Ogonek E',
  'latin capital letter e with caron': 'Caron E',
  'latin capital letter g with circumflex': 'Circumflex G',
  'latin capital letter g with breve': 'Breve G',
  'latin capital letter g with dot above': 'Dot above G',
  'latin capital letter g with comma': 'Comma G',
  'latin capital letter h with circumflex': 'Circumflex H',
  'latin capital letter h with stroke': 'Stroke H',
  'latin capital letter i with tilde': 'Tilde I',
  'latin capital letter i with macron': 'Macron I',
  'latin capital letter i with breve': 'Breve I',
  'latin capital letter i with ogonek': 'Ogonek I',
  'latin capital letter i with dot above': 'Dot above I',
  'latin capital letter ij': 'IJ',
  'latin capital letter j with circumflex': 'Circumflex J',
  'latin capital letter k with comma': 'Comma K',
  'latin small letter kra': 'Kra',
  'latin capital letter l with acute': 'Acute L',
  'latin capital letter l with comma': 'Comma L',
  'latin capital letter l with caron': 'Caron L',
  'latin capital letter l with middle dot': 'Middle dot L',
  'latin capital letter l with stroke': 'Stroke L',
  'latin capital letter n with acute': 'Acute N',
  'latin capital letter n with comma': 'Comma N',
  'latin capital letter n with caron': 'Caron N',
  'latin capital letter n with preceded by apostrophe': 'Apostrophe N',
  'latin capital letter eng': 'Eng',
  'latin capital letter o with macron': 'Macron O',
  'latin capital letter o with breve': 'Breve O',
  'latin capital letter o with double acute': 'Double acute O',
  'latin capital ligature oe': 'Ligature OE',
  'latin capital letter r with acute': 'Acute R',
  'latin capital letter r with comma': 'Comma R',
  'latin capital letter r with caron': 'Caron R',
  'latin capital letter s with acute': 'Acute S',
  'latin capital letter s with circumflex': 'Circumflex S',
  'latin capital letter s with cedilla': 'Cedilla S',
  'latin capital letter s with caron': 'Caron S',
  'latin capital letter t with cedilla': 'Cedilla T',
  'latin capital letter t with caron': 'Caron T',
  'latin capital letter t with stroke': 'Stroke T',
  'latin capital letter u with tilde': 'Tilde U',
  'latin capital letter u with macron': 'Macron U',
  'latin capital letter u with breve': 'Breve U',
  'latin capital letter u with ring above': 'Ring above U',
  'latin capital letter u with double acute': 'Double acute U',
  'latin capital letter u with ogonek': 'Ogonek U',
  'latin capital letter w with circumflex': 'Circumflex W',
  'latin capital letter y with circumflex': 'Circumflex Y',
  'latin capital letter y with diaeresis': 'Diaeresis Y',
  'latin capital letter z with acute': 'Acute Z',
  'latin capital letter z with dot above': 'Dot above Z',
  'latin capital letter z with caron': 'Caron Z',
  'latin small letter long s': 'Long s',
  'latin small letter a with macron': 'Macron a',
  'latin small letter a with breve': 'Breve a',
  'latin small letter a with ogonek': 'Ogonek a',
  'latin small letter c with acute': 'Acute c',
  'latin small letter c with circumflex': 'Circumflex c',
  'latin small letter c with dot above': 'Dot above c',
  'latin small letter c with caron': 'Caron c',
  'latin small letter d with caron': 'Caron d',
  'latin small letter d with stroke': 'Stroke d',
  'latin small letter e with macron': 'Macron e',
  'latin small letter e with breve': 'Breve e',
  'latin small letter e with dot above': 'Dot above e',
  'latin small letter e with ogonek': 'Ogonek e',
  'latin small letter e with caron': 'Caron e',
  'latin small letter g with circumflex': 'Circumflex g',
  'latin small letter g with breve': 'Breve g',
  'latin small letter g with dot above': 'Dot above g',
  'latin small letter g with comma': 'Comma g',
  'latin small letter h with circumflex': 'Circumflex h',
  'latin small letter h with stroke': 'Stroke h',
  'latin small letter i with tilde': 'Tilde i',
  'latin small letter i with macron': 'Macron i',
  'latin small letter i with breve': 'Breve i',
  'latin small letter i with ogonek': 'Ogonek i',
  'latin small letter i with dot above': 'Dot above i',
  'latin small letter ij': 'ij',
  'latin small letter j with circumflex': 'Circumflex j',
  'latin small letter k with comma': 'Comma k',
  'latin small letter k with caron': 'Caron k',
  'latin small letter l with acute': 'Acute l',
  'latin small letter l with comma': 'Comma l',
  'latin small letter l with caron': 'Caron l',
  'latin small letter l with middle dot': 'Middle dot l',
  'latin small letter l with stroke': 'Stroke l',
  'latin small letter n with acute': 'Acute n',
  'latin small letter n with comma': 'Comma n',
  'latin small letter n with caron': 'Caron n',
  'latin small letter n with preceded by apostrophe': 'Apostrophe n',
  'latin small letter eng': 'eng',
  'latin small letter o with macron': 'Macron o',
  'latin small letter o with breve': 'Breve o',
  'latin small letter o with double acute': 'Double acute o',
  'latin small ligature oe': 'Ligature oe',
  'latin small letter r with acute': 'Acute r',
  'latin small letter r with comma': 'Comma r',
  'latin small letter r with caron': 'Caron r',
  'latin small letter s with acute': 'Acute s',
  'latin small letter s with circumflex': 'Circumflex s',
  'latin small letter s with cedilla': 'Cedilla s',
  'latin small letter s with caron': 'Caron s',
  'latin small letter t with cedilla': 'Cedilla t',
  'latin small letter t with caron': 'Caron t',
  'latin small letter t with stroke': 'Stroke t',
  'latin small letter u with tilde': 'Tilde u',
  'latin small letter u with macron': 'Macron u',
  'latin small letter u with breve': 'Breve u',
  'latin small letter u with ring above': 'Ring above u',
  'latin small letter u with double acute': 'Double acute u',
  'latin small letter u with ogonek': 'Ogonek u',
  'latin small letter w with circumflex': 'Circumflex w',
  'latin small letter y with circumflex': 'Circumflex y',
  'latin small letter z with acute': 'Acute z',
  'latin small letter z with dot above': 'Dot above z',
  'latin small letter z with caron': 'Caron z',
  'latin small letter s with long s': 'Long s with s',
  'box drawings light horizontal': 'Light horizontal',
  'box drawings heavy horizontal': 'Heavy horizontal',
  'box drawings double horizontal': 'Double horizontal',
  'box drawings light vertical': 'Light vertical',
  'box drawings heavy vertical': 'Heavy vertical',
  'box drawings double vertical': 'Double vertical',
  'box drawings light down and right': 'Light down and right',
  'box drawings heavy down and right': 'Heavy down and right',
  'box drawings double down and right': 'Double down and right',
  'box drawings light down and left': 'Light down and left',
  'box drawings heavy down and left': 'Heavy down and left',
  'box drawings double down and left': 'Double down and left',
  'box drawings light up and right': 'Light up and right',
  'box drawings heavy up and right': 'Heavy up and right',
  'box drawings double up and right': 'Double up and right',
  'box drawings light up and left': 'Light up and left',
  'box drawings heavy up and left': 'Heavy up and left',
  'box drawings double up and left': 'Double up and left',
  'box drawings light vertical and horizontal': 'Light vertical and horizontal',
  'box drawings heavy vertical and horizontal': 'Heavy vertical and horizontal',
  'box drawings double vertical and horizontal': 'Double vertical and horizontal',
  'leftwards arrow': '左箭头',
  'upwards arrow': '上箭头',
  'rightwards arrow': '右箭头',
  'downwards arrow': '下箭头',
  'left right arrow': '左右箭头',
  'up down arrow': '上下箭头',
  'north west arrow': '西北箭头',
  'north east arrow': '东北箭头',
  'south east arrow': '东南箭头',
  'south west arrow': '西南箭头',
  'leftwards dashed arrow': 'Leftwards dashed arrow',
  'upwards dashed arrow': 'Upwards dashed arrow',
  'rightwards dashed arrow': 'Rightwards dashed arrow',
  'downwards dashed arrow': 'Downwards dashed arrow',
  'leftwards arrow to bar': 'Leftwards arrow to bar',
  'rightwards arrow to bar': 'Rightwards arrow to bar',
  'leftwards paired arrows': 'Leftwards paired arrows',
  'upwards paired arrows': 'Upwards paired arrows',
  'rightwards paired arrows': 'Rightwards paired arrows',
  'downwards paired arrows': 'Downwards paired arrows',
  'leftwards harpoon with barb upwards': 'Leftwards harpoon with barb upwards',
  'leftwards harpoon with barb downwards': 'Leftwards harpoon with barb downwards',
  'upwards harpoon with barb rightwards': 'Upwards harpoon with barb rightwards',
  'upwards harpoon with barb leftwards': 'Upwards harpoon with barb leftwards',
  'rightwards harpoon with barb upwards': 'Rightwards harpoon with barb upwards',
  'rightwards harpoon with barb downwards': 'Rightwards harpoon with barb downwards',
  'downwards harpoon with barb rightwards': 'Downwards harpoon with barb rightwards',
  'downwards harpoon with barb leftwards': 'Downwards harpoon with barb leftwards',
  'leftwards arrow over rightwards arrow': 'Leftwards arrow over rightwards arrow',
  'rightwards arrow over leftwards arrow': 'Rightwards arrow over leftwards arrow',
  'leftwards arrow with hook': 'Leftwards arrow with hook',
  'rightwards arrow with hook': 'Rightwards arrow with hook',
  'leftwards arrow with loop': 'Leftwards arrow with loop',
  'rightwards arrow with loop': 'Rightwards arrow with loop',
  'left right double arrow': 'Left right double arrow',
  'left right arrow with stroke': 'Left right arrow with stroke',
  'leftwards arrow with tail': 'Leftwards arrow with tail',
  'rightwards arrow with tail': 'Rightwards arrow with tail',
  'leftwards double arrow': 'Leftwards double arrow',
  'upwards double arrow': 'Upwards double arrow',
  'rightwards double arrow': 'Rightwards double arrow',
  'downwards double arrow': 'Downwards double arrow',
  'up down double arrow': 'Up down double arrow',
  'rightwards arrow from wall': 'Rightwards arrow from wall',
  'north west arrow to corner': 'North west arrow to corner',
  'rightwards arrow with corner downwards': 'Rightwards arrow with corner downwards',
  'downwards paired arrows with high flight': 'Downwards paired arrows with high flight',
  'rightwards arrow with tip downwards': 'Rightwards arrow with tip downwards',
  'rightwards arrow with tip upwards': 'Rightwards arrow with tip upwards',
  'anticlockwise open circle arrow': 'Anticlockwise open circle arrow',
  'clockwise open circle arrow': 'Clockwise open circle arrow',
  'rightwards arrow above short leftwards arrow': 'Rightwards arrow above short leftwards arrow',
  'leftwards arrow above short rightwards arrow': 'Leftwards arrow above short rightwards arrow',
  'anticlockwise gapped circle arrow': 'Anticlockwise gapped circle arrow',
  'clockwise gapped circle arrow': 'Clockwise gapped circle arrow',
  'long leftwards arrow': 'Long leftwards arrow',
  'long rightwards arrow': 'Long rightwards arrow',
  'long left right arrow': 'Long left right arrow',
  'long leftwards double arrow': 'Long leftwards double arrow',
  'long rightwards double arrow': 'Long rightwards double arrow',
  'long left right double arrow': 'Long left right double arrow',
  'upwards arrow with tip leftwards': 'Upwards arrow with tip leftwards',
  'upwards arrow with tip rightwards': 'Upwards arrow with tip rightwards',
  'downwards arrow with tip leftwards': 'Downwards arrow with tip leftwards',
  'downwards arrow with tip rightwards': 'Downwards arrow with tip rightwards',
  'rightwards arrow with stroke': 'Rightwards arrow with stroke',
  'downwards arrow with corner leftwards': 'Downwards arrow with corner leftwards',
  'upwards quadruple arrow': 'Upwards quadruple arrow',
  'downwards quadruple arrow': 'Downwards quadruple arrow',
  'anticlockwise triangle-headed open circle arrow': 'Anticlockwise triangle-headed open circle arrow',
  'clockwise triangle-headed open circle arrow': 'Clockwise triangle-headed open circle arrow',
  'downwards triangle-headed zigzag arrow': 'Downwards triangle-headed zigzag arrow',
  'leftwards triangle-headed arrow with double vertical stroke': 'Leftwards triangle-headed arrow with double vertical stroke',
  'rightwards triangle-headed arrow with double vertical stroke': 'Rightwards triangle-headed arrow with double vertical stroke',
  'leftwards triangle-headed arrow with double horizontal stroke': 'Leftwards triangle-headed arrow with double horizontal stroke',
  'rightwards triangle-headed arrow with double horizontal stroke': 'Rightwards triangle-headed arrow with double horizontal stroke',
  'dashed triangle-headed rightwards arrow': 'Dashed triangle-headed rightwards arrow',
  'zigzag rightwards arrow': 'Zigzag rightwards arrow',
  'leftwards triangle-headed arrow with loop': 'Leftwards triangle-headed arrow with loop',
  'rightwards triangle-headed arrow with loop': 'Rightwards triangle-headed arrow with loop',
  'leftwards triangle-headed arrow to bar': 'Leftwards triangle-headed arrow to bar',
  'rightwards triangle-headed arrow to bar': 'Rightwards triangle-headed arrow to bar',
  'rightwards triangle-headed arrow with reflection': 'Rightwards triangle-headed arrow with reflection',
  'upwards triangle-headed arrow with reflection': 'Upwards triangle-headed arrow with reflection',
  'leftwards triangle-headed paired arrows': 'Leftwards triangle-headed paired arrows',
  'rightwards triangle-headed paired arrows': 'Rightwards triangle-headed paired arrows',
  'upwards triangle-headed paired arrows': 'Upwards triangle-headed paired arrows',
  'downwards triangle-headed paired arrows': 'Downwards triangle-headed paired arrows',
  'leftwards triangle-headed arrow from wall': 'Leftwards triangle-headed arrow from wall',
  'rightwards triangle-headed arrow from wall': 'Rightwards triangle-headed arrow from wall',
  'leftwards triangle-headed arrow with vertical stroke': 'Leftwards triangle-headed arrow with vertical stroke',
  'rightwards triangle-headed arrow with vertical stroke': 'Rightwards triangle-headed arrow with vertical stroke',
  'leftwards triangle-headed arrow with double vertical stroke': 'Leftwards triangle-headed arrow with double vertical stroke',
  'rightwards triangle-headed arrow with double vertical stroke': 'Rightwards triangle-headed arrow with double vertical stroke',
  'leftwards triangle-headed arrow with circle plus': 'Leftwards triangle-headed arrow with circle plus',
  'rightwards triangle-headed arrow with circle plus': 'Rightwards triangle-headed arrow with circle plus',
  'leftwards triangle-headed arrow with high flight': 'Leftwards triangle-headed arrow with high flight',
  'rightwards triangle-headed arrow with high flight': 'Rightwards triangle-headed arrow with high flight',
  'upwards triangle-headed arrow with high flight': 'Upwards triangle-headed arrow with high flight',
  'downwards triangle-headed arrow with high flight': 'Downwards triangle-headed arrow with high flight',
  'leftwards triangle-headed arrow to black circle': 'Leftwards triangle-headed arrow to black circle',
  'rightwards triangle-headed arrow to black circle': 'Rightwards triangle-headed arrow to black circle',
  'leftwards triangle-headed arrow': 'Leftwards triangle-headed arrow',
  'rightwards triangle-headed arrow': 'Rightwards triangle-headed arrow',
  'upwards triangle-headed arrow': 'Upwards triangle-headed arrow',
  'downwards triangle-headed arrow': 'Downwards triangle-headed arrow',
})

window.tinymce = tinymce
window.tinyMCE = tinymce

require('@/utils/tinymce/plugins/importword/plugin.js')

export default tinymce
